import React from 'react'

export function formatBlogReadingTimeLabel(minutes: number): string {
  const n = Math.floor(minutes)
  if (n <= 0) return ''
  return n === 1 ? '1 min read' : `${n} mins read`
}

type BlogReadingTimeProps = {
  minutes: number | null | undefined
  rootClassName: string
  iconClassName: string
}

export function BlogReadingTime({ minutes, rootClassName, iconClassName }: BlogReadingTimeProps) {
  if (typeof minutes !== 'number' || minutes <= 0) {
    return null
  }

  return (
    <p className={rootClassName} role='status'>
      <svg
        className={iconClassName}
        width='18'
        height='18'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden
      >
        <circle cx='12' cy='12' r='9' stroke='currentColor' strokeWidth='1.75' />
        <path
          d='M12 7v5l3 2'
          stroke='currentColor'
          strokeWidth='1.75'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
      <span>{formatBlogReadingTimeLabel(minutes)}</span>
    </p>
  )
}
